import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import { routeAnalyticsHome, routeAnalyticsRoot } from './analyticsRoutes'

const route2WorkAIHome: RouteRecordRaw = {
  name: '2work-ai-home',
  path: '',
  redirect: routeAnalyticsHome,
}

const route2WorkAIRoot: RouteRecordRaw = {
  children: [route2WorkAIHome, routeAnalyticsRoot],
  path: '2work-ai',
}

const redirect2WorkAI: RedirectRouteRelative = {
  name: route2WorkAIHome.name,
}

export { redirect2WorkAI, route2WorkAIRoot }
